import React from 'react'
import './Footer.css'
const Footer = () => {
  return (
    <div className='footer'>
      Designed and Developed By: @Gaurav Chakrawarti
    </div>
  )
}

export default Footer
